import React from "react";
import logoLC from "../../img/logoLC.jpg";
import "./navbar.css";
function Navbar() {
  return (
    <div>
      <nav>
        <div className="izq-nav">
          <h1>Lucas Luna Clarasó</h1>
        </div>
        <div className="der-nav">
          <ul>
            <li>Sobre Mi</li>
            <li>Proyectos</li>
            <li>Redes</li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
